module.exports = __webpack_public_path__ + "img/wcyg-doctor.ac27f9e4.svg";